export const translateCodes = {
    MINS: 'MINS',
    FIRST_NAME: 'FIRST_NAME',
    LAST_NAME: 'LAST_NAME',
    YOUR_EMAIL: 'YOUR_EMAIL',
    PHONE: 'PHONE',
    CONTINUE: 'CONTINUE',
    TRANSACTION_DETAILS: 'TRANSACTION_DETAILS',
    CLIENT_NAME: 'CLIENT_NAME',
    PHONE_NUMBER: 'PHONE_NUMBER',
    PAYMENT_TYPE: 'PAYMENT_TYPE',
    SALE_ID: 'SALE_ID',
    DESCRIPTION: 'DESCRIPTION',
    PRICE: 'PRICE',
    SERVICE: 'SERVICE',
    PRODUCT: 'PRODUCT',
    SUB_TOTAL: 'SUB_TOTAL',
    DISCOUNT: 'DISCOUNT',
    TAX: 'TAX',
    TIP: 'TIP',
    TOTAL_AMOUNT: 'TOTAL_AMOUNT',
    RATE_EXPERIENCE: 'RATE_EXPERIENCE',
    GIVE_FEEDBACK: 'GIVE_FEEDBACK',
    ENTER_FEEDBACK: 'ENTER_FEEDBACK',
    SUBMIT: 'SUBMIT',
    VIEW_TRANSACTION_DETAILS: 'VIEW_TRANSACTION_DETAILS',
    WE_LOVE_FEEDBACK: 'WE_LOVE_FEEDBACK',
    SHARE_EXPERIENCE_GOOGLE: 'SHARE_EXPERIENCE_GOOGLE',
    CLICK_TO_REVIEW: 'CLICK_TO_REVIEW',
    REVIEW_EXISTS: 'REVIEW_EXISTS',
    SALE_REVIEWED: 'SALE_REVIEWED',
    THANK_FOR_FEEDBACK: 'THANK_FOR_FEEDBACK',
    FEEDBACK_RECEIVED: 'FEEDBACK_RECEIVED',

};

export type TranslateResources = Record<keyof typeof translateCodes, string>;